import React, { Component, PropTypes } from 'react';
import BookingLabelValueItem from './BookingLabelValueItem';

export default class BookingPersonsItem extends Component {
    static propTypes = {
        personIds: PropTypes.array.isRequired,
        persons: PropTypes.object.isRequired,
    }

    fieldHasValue(value) {
        return !!value && value.trim().length > 0;
    }

    render() {
        const { personIds, persons } = this.props;

        const personsJsx = personIds.map(personId => {
            const { name, phoneNumber, email } = persons[personId];

            const phoneIcon = this.fieldHasValue(phoneNumber) &&
                <a href={`tel:${phoneNumber}`}><i className="material-icons">&#xE0CD;</i></a>;

            const emailIcon = this.fieldHasValue(email) &&
                <a href={`mailto:${email}`}><i className="material-icons">&#xE0BE;</i></a>;

            return (
                <BookingLabelValueItem key={personId} label={name}>
                    {phoneIcon}
                    {emailIcon}
                </BookingLabelValueItem>
            );
        });

        return (
            <div className="booking-persons-item">
                {personsJsx}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Booking/BookingPersonsItem.jsx